import React from "react";
import { Skeleton } from "../../../components/ui/Skeleton";
import PlanCard from "./PlanCard";
import { EnhancedPlan } from "../types";
import { isCurrentPlan } from "../../../utils/subscription";

interface PlanTabsProps {
    plans: EnhancedPlan[];
    loading: boolean;
    currentPlanId: string | null;
    hasActiveSubscription: boolean;
    currentSubscriptionName?: string;
    selectedPlan: string;
    onPlanSelect: (planId: string) => void;
    recommendedPlan: "basic" | "plus" | "pro";
    accessCode?: string;
    discountAmount?: number;
}

const PlanTabs: React.FC<PlanTabsProps> = ({
    plans,
    loading,
    currentPlanId,
    hasActiveSubscription,
    currentSubscriptionName,
    selectedPlan,
    onPlanSelect,
    recommendedPlan,
    accessCode,
    discountAmount = 0,
}) => {
    if (loading) {
        return (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[...Array(3)].map((_, i) => (
                    <Skeleton
                        key={i}
                        className="h-[500px] rounded-lg bg-gray-200"
                    />
                ))}
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {plans.map((plan) => {
                const isPlanSelected = plan.id === selectedPlan;
                const isPlanRecommended =
                    (recommendedPlan === "basic" && plan.price === 0) ||
                    (recommendedPlan === "plus" &&
                        plan.name.toLowerCase().includes("plus")) ||
                    (recommendedPlan === "pro" &&
                        plan.name.toLowerCase().includes("pro"));

                return (
                    <PlanCard
                        key={plan.id}
                        plan={plan}
                        isCurrent={plan.id === currentPlanId}
                        isHighlighted={isPlanRecommended}
                        currentSubscriptionName={currentSubscriptionName}
                        onClick={() => onPlanSelect(plan.id)}
                        accessCode={accessCode}
                        discountAmount={discountAmount}
                    />
                );
            })}
        </div>
    );
};

export default PlanTabs;
